import { __assign, __makeTemplateObject, __rest } from "tslib";
import React, { forwardRef, useMemo } from 'react';
import MuiTypography from '@material-ui/core/Typography';
import { styled, useThemeProps, } from '../../foundation';
import { withTooltip } from '../Tooltip';
import { TypographyStyle } from './styles';
import { MuiDefaultColor, RcCustomTypographyVariant } from './utils';
var _RcTypography = forwardRef(function (inProps, ref) {
    var props = useThemeProps({ props: inProps, name: 'RcTypography' });
    var variant = props.variant, colorProp = props.color, componentProp = props.component, weight = props.weight, rest = __rest(props, ["variant", "color", "component", "weight"]);
    var component = componentProp || RcCustomTypographyVariant[variant];
    var color = useMemo(function () {
        return MuiDefaultColor.includes(colorProp) ? colorProp : undefined;
    }, [colorProp]);
    return (React.createElement(MuiTypography
    // * for use html view variant
    , __assign({ "data-variant": variant, "data-color": typeof colorProp === 'string' ? colorProp : undefined, ref: ref, color: color, variant: "inherit", component: component }, rest)));
});
/** @release */
var RcTypography = styled(withTooltip(_RcTypography))(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), TypographyStyle);
RcTypography.defaultProps = {
    variant: 'body1',
    color: 'initial',
};
RcTypography.displayName = 'RcTypography';
export { RcTypography };
var templateObject_1;
